import EditorNav from "@/components/EditorNav";
import Stepper from "@/components/Stepper";
import Sidebar from "@/components/Sidebar";
import Steps from "@/components/Steps";
import cognitoAuth from "@/plugins/cognito";
import GqlQuery from "@/plugins/gql";
import featureGate from '@/mixins/featureGate'



let updated_duration=0;
let apiGPrefix = process.env.GQL_ENDPOINT;
apiGPrefix = apiGPrefix.replace("gql", "");
const axios = require("axios");
var inactiveColor = "#58595b";
var colors = ["#25aae1", "#8cc63f", "#f172a6", "#13a89e", "#fcb040", "#8cc63f"];
var draftFields = ['steps', 'description', 'title', 'time_to_complete', 'video_url', 'thumbnail_url', 'browser_title', 'raw_url', 'video_duration']
var slugify = function (text_to_slugify) {
  return text_to_slugify
    .toLowerCase()
    .replace(/[^\w ]+/g, "")
    .replace(/ +/g, "-");
};
var obUrl;
var EFFECT_DURATION = 300;
var PLACEHOLDER_TITLE = "Hello, world.";
var PLACEHOLDER_DESC = '<p>Have an intro? Make the title of this step "Intro" or "Introduction" to not assign a step # here. </p><p> Highlight text or use keyboard shortcuts to bold, italicize, underline, link, and/or create ordered/unordered lists.</p>';

export default {
  updated() {
    let self = this;
    M.AutoInit();
    $(".collapsible-header.active").on("click", e => e.stopPropagation());
  },
  mixins: [featureGate],
  async mounted() {
    var effectInProgress = false;
    var canPassEffect = false;

    let self = this;
    document.title = "fyiio | tutorial editor"
    cognitoAuth.getIdToken(function (err, jwttoken) {
      self.token = jwttoken;
    });
    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function(err, user_attributes) {
          self.user_org = user_attributes['custom:organization_id'];
          self.user_email = user_attributes['email'];
          if (self.id) {
            self.loadTutorial();
          } else {
            self.tutorialLoading = false;
          }
        });
        //Check Plan
        var hold=false;
        self.getPlanAllowedVideoDuration().then(
          function(result){
            console.log("Plan allowed duration is:",result)
            self.planAllowedVideoDuration=result;
          }
        );
        //This is a feature flag where video allowed duration may be overridden on an org level by the account manager
       /* self.checkPlanForVideoUpload().then(
          function(result){
            console.log("Allow long form video is:",result)
            self.planAllowsLongFormVideo=result;
          }
        )*/
      }
    });
    M.AutoInit();

    $(window).bind("beforeunload", function (event) {
      if (self.uploading) return "You have unsaved changes";
    });
  },

  created() {
    this.resizeHandler();
    window.addEventListener("resize", this.resizeHandler);
  },
  destroyed() {
    document.removeEventListener("resize", this.resizeHandler);
  },

  name: "NewTemplate",
  data() {
    return {
      planAllowsLongFormVideo:false,
      id: this.$route.params.id,
      remoteWaits:0,
      token: false, // used to auth gql requests
      myDropzone: false, // saves dropzone reference
      slider: false, // save slider reference

      stepActionsDisabled: false,
      showInstructions: false, // show Upload or Create step instruction screen
      creatingSteps: false,
      tutorialLoading: true, // show linear indefinite progress loader while loading
      editing: false, // if currently editing a step
      updatingStep: false, // currently updating step, e.g., saving draft
      syncing: false, // syncing step to video
      processing: false, // processing video
      uploading: false, // currently uploading video
      needsResync: false, // set to true when step is deleted or video is replaced, will trigger resync in loadTutorial()
      replacingVideo: false, 
      reloadAttemptsCount: 0,
      resyncing: false, // currently resycing
      canResyncNext: false, // if currently resyncing step has a duration
      loadingPreview: false, // saving draft, then will go to preview step
      videoError: false,
      videoErrorUpgradeRequired:false,
      didUploadVideo: false,
      

      // save tutorial in various states
      tutorial: {}, // mix of published tutorial data and draft data
      originalTutorial: false, // save original tutorial to provide default data and cancel functionality
      editStepRevert: false, // saves this.step to provide cancel functionality

      // tutorial info, mostly from draft in loadTutorial()
      title: "",
      description: "",
      browser_title: "",
      time_to_complete: "",
      steps: [
        {
          title: PLACEHOLDER_TITLE,
          start_time: 0,
          end_time: 1,
          description: PLACEHOLDER_DESC
        }
      ],
      published: false,
      posted_at: false,
      video_url: null, // CDN url for video
      raw_url: null, // useful in case video_url CDN isn't working yet
      video_duration: 0, // saved after jwplayer loads video, TODO add this to backend

      current_step: 0, // index of the currently selected step
      uploadProgress: 0, // 0-100 percent progress of upload
      colors: colors, // step colors
      user_org: false,
      user_email: false,

      lastUpdated: false
    };
  },

  computed: {
    videoUrl: function() {
      let url_to_load=this.video_url;
      let xurl=url_to_load;
      xurl=xurl.replace(" ", "+")
      return xurl
    },
    hasVideo: function () {
      return this.video_url !== null && this.video_url !== undefined && this.video_url.length > 5;
    },
    canPreview: function () {
      if (!this.steps || !this.steps.length || this.steps.length === 0) { return }
      return Math.floor(this.steps[this.steps.length - 1].end_time) === Math.floor(this.video_duration) && this.canSaveCurrentStep;
    },
    canSaveCurrentStep: function () {
      let step = this.steps[this.current_step]
      return step.title && step.title.length > 0 && step.description && step.description.length > 0
    },
    canEditFirstStep: function () {
      return this.creatingSteps || this.video_url && !this.uploading || this.steps.length > 1
    },
    stepsEdited: function() {
      return this.steps[0].title != PLACEHOLDER_TITLE || this.steps[0].description != PLACEHOLDER_DESC
    },
    addAnotherDisabled: function () {
      let self = this
      if (this.processing || this.uploading) { return true }
      if (this.current_step == 0) {
        if (this.steps[0].title != PLACEHOLDER_TITLE || this.steps[0].description != PLACEHOLDER_DESC) {
        } else {
          return true
        }
      } 
        let step = this.steps[this.steps.length -1]
        if (self.video_url || self.raw_url) {

          if (Math.floor(step.start_time) == Math.floor(step.end_time) || Math.floor(step.end_time) -  Math.floor(step.start_time) == 1 ) {
            return true
          }
        }

        if (step.title.length < 1 || step.description.replace(/(<([^>]+)>)/ig,"").length < 1) {
          return true
        }
      return false
    }
  },

  methods: {
    isMobile() {
      if( screen.width <= 760 ) {
          console.log("mobile:", screen.width)
          return true;
      }
      else {
          console.log("Not mobile:", screen.width)
          return false;
      }
    },
    noOp() {
      console.log("No operation");
      return
    },
    resizeHandler() {
      if (!document.getElementById("playercolumn")) return;
      let self = this
      let height = document.getElementById("playercolumn").offsetHeight - 108;
      if (height<200){
        height=300;  //set minimum height
      }
      document.getElementById(
        "steps-gradient-scroller"
      ).style.height = `${height}px`;
      if (height <=200) {
        setTimeout(function () {
          self.resizeHandler()
        }, 250)
      }
    },

    setVideoError(err) {
      var self = this;
      this.video_url = null;
      this.raw_url = null;
      this.processing = false;
      this.uploading = false;
      this.myDropzone = false;
      this.editing = false;
      this.resyncing = false;
      try{
        jwplayer().remove()
      }catch(err){
        console.log("Video player not loaded.");
      }
      self.videoError = err;
      setTimeout(function () {
        self.resizeHandler()
      }, 250)
    },

    // Intro Screen functions
    createSteps() {
      let self = this
      setTimeout(function () {
        self.creatingSteps = true;
        self.showInstructions = false;
        self.videoError = false;
        self.editStep(0)
        setTimeout(function () {
          self.resizeHandler()
        }, 250)
      }, EFFECT_DURATION)
    },

    startUpload() {
      console.log("startUpload")
      let self = this
      self.replacingVideo=true;
      $("#uploader").trigger("click");
      setTimeout(function () {
        self.videoError = false;
        if (!self.myDropzone || !$('#uploader').hasClass('dropzone')) {
          self.setUpDropzone();
        }
      }, EFFECT_DURATION)
    },

    fileExists() {
        let self = this;
        var xhr = new XMLHttpRequest()
        if(self.replacingVideo){
          xhr.withCredentials=false;
        }else{
          xhr.withCredentials=true;
        }

        xhr.onload = function() {
          if(xhr.status==404 || xhr.status==403){
            xhr.abort();
            self.reloadAttemptsCount++;
            if(self.reloadAttemptsCount>20){
                self.setVideoError("Your video is taking some extra time to prepare.");
                setTimeout(() => {
                  location.reload()
                }, 1500);
                return;
            } else{             
              setTimeout(() => {
                    self.fileExists();
              }, 7500);
            }
          } else if(xhr.status==200){
             xhr.abort();
             if(self.replacingVideo){
              window.location.reload(); 
             }else{
               self.setUpVideo();
             }
           }
        }
        //xhr.addEventListener("error", (e) => { console.error('xhr.onerror',e) })
        let xurl=self.videoUrl;
        xurl=xurl.replace(" ", "+")
        xhr.open('HEAD', xurl, true);
        xhr.send(null);
    },
    // Set up Template methods
    loadTutorial(cb) {
      let self = this;

      GqlQuery.getTutorial(this.id, "en", function (err, response) {
        if (err) {
          self.error = err;
          return
        }

        response.json().then(function (val) {
          if (!val.data || !val.data.chapter) {
            return
          }
          self.tutorialLoading = false
          self.originalTutorial = val.data.chapter;
          var tutorial = val.data.chapter;
          //console.log("tutorial org id: ", tutorial.organization.id ) 
          let authed = (self.user_org && tutorial.organization && tutorial.organization.id == self.user_org);
          /*console.log("authed is ", authed)
          console.log("user org is", self.user_org)
          console.log("tutorial org name is", tutorial.organization.name)
          console.log("tutorial org is " , tutorial.organization.id)
          */
          if (!authed && self.user_email != 'alex@fyi.io') {
            M.toast({
              html:
                "You are not authorized to edit this tutorial",
              inDuration: 3000
            });
            window.location = "/tutorials"
            return
          }
          let originalDraft = {}
          if (tutorial.draft) {
            originalDraft = JSON.parse(tutorial.draft)
          }

          let draft = {
            steps: originalDraft.steps || tutorial.steps,
            description: originalDraft.description || tutorial.description,
            title: originalDraft.title || tutorial.title,
            time_to_complete: originalDraft.time_to_complete || tutorial.time_to_complete,
            video_url: originalDraft.video_url || tutorial.video_url,
            thumbnail_url: originalDraft.thumbnail_url || tutorial.thumbnail_url,
            browser_title: originalDraft.browser_title || tutorial.browser_title,
            raw_url: originalDraft.raw_url || tutorial.raw_url,
            video_duration: originalDraft.video_duration || tutorial.video_duration
          }

          if (tutorial.video_upload) {
            var video_upload = JSON.parse(tutorial.video_upload)
            draft.video_url = video_upload.video_url
            draft.thumbnail_url = video_upload.thumbnail_url
            draft.browser_title = video_upload.browser_title
            draft.raw_url = video_upload.raw_url
          }
          draftFields.forEach(function (field) {
            if (!draft[field]) {
              draft[field] = tutorial[field]
            }
          })

          if (tutorial) {
            let cleanTitle = tutorial.title.replace(/-/g, " ")
            if (draft && draft.title) {
              cleanTitle = draft.title.replace(/-/g, " ")
            }
            self.tutorial = tutorial;
            self.title = cleanTitle;
            self.browser_title = tutorial.browser_title.replace(/-/g, " ");
            self.description = draft.description;
            self.time_to_complete = draft.time_to_complete;
            if (draft.steps && draft.steps.length > 0) {
              self.steps = draft.steps.sort(function (a, b) {
                return parseInt(a.i) - parseInt(b.i);
              });
            } else if (draft.steps && draft.steps.length == 0 && tutorial.steps && tutorial.steps.length > 0) {
              self.steps = tutorial.steps.sort(function (a, b) {
                return parseInt(a.i) - parseInt(b.i);
              });
            }
            self.steps.forEach(function (step, i) {
              self.steps[i].i = i;
            })
            self.video_url = draft.video_url;
            self.raw_url = draft.raw_url;
            self.video_duration = Math.floor(draft.video_duration)
            self.article_id = tutorial.article_id;
            self.published = tutorial.published;
            self.posted_at = tutorial.posted_at;
            if (self.tutorial.steps.length < 2 && !self.hasVideo && self.steps[0].title == PLACEHOLDER_TITLE && self.steps[0].description == PLACEHOLDER_DESC) {
              self.showInstructions = true
            } else {
              self.showInstructions = false
            }

            if (!self.hasVideo) {
              self.setUpDropzone();
            } else {
              $("#uploader").removeClass("dropzone");
              $("#uploader").empty();
              if(self.replacingVideo){
                setTimeout(() => {
                  self.setUpEditor();
                  self.fileExists();
                }, 500);
              } else {
                self.setUpEditor();
                self.setUpVideo();
              }
            }

            let activeStep = self.resyncing
              ? self.current_step + 1
              : self.current_step;
            self.selectStep(activeStep);

            self.tutorialLoading = false

            if (self.needsResync) {
              self.needsResync = false
              self.resyncSteps()
            }

            if (self.video_url && self.steps.length > 1 && Math.floor(self.steps[self.steps.length -1].end_time) > Math.floor(self.video_duration) ) {
              // if the user replaced the video with a shorter video
              self.resyncSteps()
            }
            let unSyncedSteps = false
            for (const i in self.steps) {
              let step = self.steps[i]
              if ( (Math.floor(step.end_time) - Math.floor(step.start_time) < 1) || !step.end_time || (!step.start_time && step.start_time != 0) ) {
                unSyncedSteps = true
              }
            }
            if (self.video_url && unSyncedSteps) {
              if(draft.steps.length>1){
                for (const i in draft.steps) {
                  let step = draft.steps[i]
                }
              }else{
                self.resyncSteps()
              }

            }

            if (cb && typeof cb === "function") {
              cb();
            }
          }
        });
      });
    },

    setUpVideo() {
      let self = this;

      jwplayer("player").setup({
        file: "assets/120.mp4",
        mute: true,
        tracks: [],
        displaytitle: false,
        width: "100%",
        aspectratio: "16:9"
      });
      jwplayer().load([
        {
          file: self.videoUrl
        }
      ]);
      jwplayer().pause(true);

      let errorcount = 0;
      jwplayer().on("error", function (err) {
        console.log("in jwplayer error", err)
        if (err.code === 224003) {
          // Handle the error here
          console.error("Error loading video.");
          jwplayer("player").load([
            {
              //reset the file to a local file so jwplayer doesn't freak out
              file: "assets/120.mp4",
            }
          ]);
          setTimeout(function () {
              self.setUpDropzone();
              self.setVideoError("There was a problem with the uploaded video. Please try again. If the problem persists, please contact Fyiio support.")
              return;
          }, EFFECT_DURATION)
          
          
          
          // You might want to do something more useful than just logging the error
        }
        // occassionally the CDN will not have the full video, in which case there will be an error loading,
        // we'll try the video_url a few times, then will default to raw_url, which goes to S3
        self.processing = true
        
        setTimeout(function () {
          errorcount++;
          if (errorcount > 20 || (errorcount > 4 && !self.didUploadVideo)) {
            if (self.didUploadVideo) {
              self.setVideoError("There was a problem loading your video, please try again or contact Fyiio support")
            } else {
              self.setVideoError("Uploading video failed. Please try uploading it again.")
            }
            return;
          } else{
            
            console.log("bubba")
          }

        }, 1000)

      });
      let initialPausePerformed = false;
      jwplayer().on("time", function (e) {
        if (
          e.position >= 0 &&
          e.position <= 1.1 &&
          initialPausePerformed == false
        ) {

          jwplayer().pause(true);
          initialPausePerformed = true;

        }

        if (e.duration > 4) {
          if (self.video_duration == 0 || self.video_duration == NaN || !self.video_duration) {
            self.video_duration = Math.floor(e.duration);
          }

          if (self.processing) {
            self.processing = false
            if (self.steps.length == 1) {
              // self.editing = true
              self.editStep(0)
            }

          }
        }
        if (!self.slider || (updated_duration>0)) {
          if(updated_duration>0){
            self.setUpSlider(updated_duration);
          }else{
            self.setUpSlider(self.video_duration);
            console.log("steps length is ", self.steps.length);
            if (self.steps.length > 1) { //indicates that steps have been added, not just the default step exists
              if(self.steps[0].end_time==undefined || (self.steps[0].end_time-self.steps[0].start_time<2)){
                try{
                  if(draft!=undefined && draft.steps.length>1){
                  }else{
                    self.resyncSteps()
                  }
                }catch(err) {
                  self.resyncSteps()
                }
               
              }
            }
          }

        }
      });
    },

    setUpDropzone() {
      $('#bubbaModal').modal();
      $("#uploader").addClass("dropzone");

      let self = this;
      if (self.myDropzone) {
        self.myDropzone.removeAllFiles(true);
        self.myDropzone = null
      }
      Dropzone.prototype.defaultOptions.dictDefaultMessage = "";
      Dropzone.options.player = {
        acceptedFiles: ".mp4,.avi"
      };

      if ($('div#uploader').length==0) {
        setTimeout(function () {
          self.setUpDropzone();
        }, 250)
        return;
      }

      var myDropzone = new Dropzone("div#uploader", {
        url: "/",
        method: "PUT",
        maxFilesize: 10000,
        timeout: 0,
        acceptedFiles: ".mp4,.avi",
        parallelUploads: 1,
        uploadMultiple: false,
        autoQueue: false,
        renameFile: function (file) {
          var filename = new Date().getTime() + "_" + file.name;
          return filename;
        },
        success: function (file, res) {
          self.didUploadVideo = true
          self.updateTutorialDraft()
          self.uploading = false
          self.current_step = 0;
          $("#uploader").removeClass("dropzone");
          self.processing = true
          self.stepActionsDisabled = false
          self.loadTutorial();
          setTimeout(function () {
            self.resizeHandler()
          }, 250)
        },
        error: function (file, res) {
          console.log("Upload error.");
          console.log(res);
        }
      });

      myDropzone.on("processing", function (file) {
        this.options.url = file.uploadURL;
      });

      myDropzone.on("totaluploadprogress", function (progress) {
        self.uploadProgress = progress
      });

      myDropzone.on("addedfile", function (file) {
        console.log('here');
        var that = this
        self.showInstructions = false
        self.processing = true
        self.uploading = true
        self.editing = false
        self.uploadProgress = 0

        if (self.steps.length > 1) {
          self.needsResync = true
        }
        let token = self.token;
        let posted = self.tutorial.posted_at;
        var instance = axios.create({});
        var tutorialName = slugify($("#contentTitle").text());
        let namespace = self.tutorial.organization.name;
        instance.defaults.headers.common["Authorization"] = token;
        let postedFileName = new Date().getTime() + "_" + file.name;
        let fileIsValid = true
        if (file.name.match(/\.(avi|mov|mp4)$/i)) {
          obUrl = URL.createObjectURL(file);
          // figure out the duration of the video by adding it to an audio element, then getting duration
          document.getElementById('audio').setAttribute('src', obUrl);
          setTimeout(function () {
            let duration = document.getElementById('audio').duration;
            updated_duration=duration;
            self.processing = false
            self.video_duration = Math.floor(duration)
            let allow_longform_video_account_override=false;  
            let check_longform=self.tutorial.organization.allow_longform_video;
            if(check_longform && check_longform==true){
              allow_longform_video_account_override=true;
            }
            
            console.log("PlanAllowedDuration is ", self.planAllowedVideoDuration);
            if (duration > self.planAllowedVideoDuration && !allow_longform_video_account_override) {
              myDropzone.removeFile(file);
              console.log("duration is ", duration)
              fileIsValid = false
              that.removeFile(file)
              self.uploading = false
              self.videoError =  self.planAllowedVideoDuration/60 + " minutes is the maximum allowed duration for your plan."
              self.videoErrorUpgradeRequired=true;
              //const elem = document.getElementById('bubbaModal');
              
              /*$("#bubbaModal").modal();
              setTimeout(function () {
                $("#bubbaModal").modal("open")
              }, 250)*/
              //console.log("afteropen")
              
              //let instancex = M.Modal.init(elem, {dismissible: false});
              //instancex.open();
              
            }else{
              console.log(self.user_org)
              if(duration > 3600){
                myDropzone.removeFile(file);
                fileIsValid = false
                that.removeFile(file)
                self.uploading = false
                self.videoError = "Error: Video over 60 minutes long — please upload a shorter video, or contact us to request an exception"
                self.videoErrorUpgradeRequired=true;
              }
            }
            
          }, 200)

        } else {
          fileIsValid = false
          myDropzone.removeFile(file);
          self.uploading = false
          self.processing = false
          self.videoError = "Unsupported video format — video must be MP4 or AVI"
        }

        setTimeout(function () {
          if (fileIsValid && !self.videoError) {
            axios
              .post(`${apiGPrefix}prepare-upload`, {
                fileName: postedFileName,
                contentType: file.type,
                namespace: namespace,
                tutorial: slugify(self.title),
                article_id: self.article_id,
                posted_at: posted
              })
              .then(function (response) {
                var urlSave = response.data;
                file.uploadURL = urlSave;
                myDropzone.enqueueFile(file);
                if (self.videoError) {
                  if (self.tutorial.video_upload) {
                    var video_upload = JSON.parse(self.tutorial.video_upload)
                    self.video_url = video_upload.video_url
                    self.raw_url = video_upload.raw_url
                    self.updateTutorialDraft()
                  }
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        }, 300)
      });

      myDropzone.on("sending", function (file, xhr) {
        let _send = xhr.send;
        xhr.send = () => {
          _send.call(xhr, file);
        };
      });

      self.myDropzone = myDropzone
    },

    setUpSlider(maxxer) {
      if (!this.video_url || this.videoError) {
        console.log("setUpSlider return early because no video_url or has videoError")
        return
      }

      if ((isNaN(maxxer) || maxxer == null) && !this.video_duration) {
        return
      } else {
        if(updated_duration>0){
          maxxer = updated_duration;
        }else{
          maxxer = this.video_duration;
        }
        
      }
      if (this.slider) {
        this.slider.noUiSlider.destroy();
      }
      let self = this;
      let slider = document.getElementById("test-slider");
      let starts = [0, 0];
      if (this.steps && this.steps[0]) {
        starts = this.steps.map(step => parseFloat(step.end_time));
      }
      if (starts.length === 1) {
        starts.unshift(0);
      }
      let connects = [true];
      starts.forEach(start => {
        connects.push(true);
      });

      connects[connects.length - 1] = false;
      noUiSlider.create(slider, {
        start: starts,
        step: 1,
        connect: connects,
        orientation: "horizontal",
        range: {
          min: [0],
          max: [maxxer]
        },
        format: wNumb({
          decimals: 1
        })
      });
      var origins = slider.getElementsByClassName("noUi-origin");
      var connect = slider.querySelectorAll(".noUi-connect");

      self.setUpSliderColors()
      origins[0].setAttribute("disabled", true);
      slider.noUiSlider.on("slide", function (values, handle, unencodedValues) {
        var valzer = self.slider.noUiSlider.get();
        // there's some strange behavior here, the player wouldn't pause or seek correctly,
        // even though this function was clearly called.
        // added a couple settimeouts to ensure the video is at the right place and paused.
        var position = values[handle];

        jwplayer().seek(position);
        jwplayer().pause(true);
        setTimeout(function () {
          jwplayer().seek(position);
          jwplayer().pause(true);
        }, 100);
        setTimeout(function () {
          jwplayer().pause(true);
        }, 200);
        var valzer = self.slider.noUiSlider.get();
        let i = self.current_step ? self.current_step : 0;
        self.steps[i].start_time = parseFloat(valzer[valzer.length - 2]);
        self.steps[i].end_time = parseFloat(valzer[valzer.length - 1]);
        if (self.steps[i].start_time < self.steps[i].end_time) {
          self.canResyncNext = true
        } else {
          self.canResyncNext = false
        }
      }); 
      self.slider = slider;
      setTimeout(function () {
        self.resizeHandler()
      }, 250)
    },

    setUpSliderColors() {
      var self = this;
      var connect = document.querySelectorAll(".noUi-connect");
      if (this.steps.length == 1) {
        // in case ther's only one step
        connect[1].style.background = colors[0];
      } else {
        for (var i = 0; i < connect.length; i++) {
          if (!self.resyncing && i === self.current_step) {
            connect[i].style.background = colors[i % colors.length];
          } else if (self.resyncing && i == connect.length - 1) {
            connect[i].style.background = colors[self.current_step % colors.length];
          } else {
            connect[i].style.background = inactiveColor;
          }
        }
      }
    },

    setUpEditor() {
      let self = this
      if (this.editor) {
        // this.editor.destroy();
      }
      this.editor = new MediumEditor(".editable", {
        placeholder: false,
        buttonLabels: "fontawesome",
        targetBlank: true,
        anchor: {
          customClassOption: null,
          customClassOptionText: 'Button',
          linkValidation: true,
          placeholderText: 'Paste or type a link',
          targetCheckbox: false,
          targetCheckboxText: 'Open in new window'
      },
        toolbar: {
          buttons: [
            "bold",
            "italic",
            "underline",
            "anchor",
            "orderedlist",
            "unorderedlist",
            "pre"
          ]
        }
      });

      this.editor.subscribe('editableInput', function (event, editorElement) {
        self.steps[self.current_step].description = editorElement.innerHTML
      });
      setTimeout(function () {
        $('.active .title.input-field').parent().find('label').addClass('active')
      }, 100)
    },


    // Resync/Replace Methods
    resetStepTimes() {
      var self = this
      this.steps = this.steps.map((step, i) => {
        return {
          title: step.title,
          description: step.description,
          id: step.id,
          i: i
        };
      });
    },

    replaceVideo() {
      this.updateTutorialDraft()
      this.needsResync = true;
      this.replacingVideo = true;
      this.video_url = null;
      this.raw_url = null;
      this.processing = false;
      this.uploading = false;
      this.myDropzone = false;
      this.editing = false;
      this.didUploadVideo = false;
      console.log("before remove")
      jwplayer().remove()
      console.log("after remove")
      this.resetStepTimes();
      this.setUpSlider();
      this.setUpDropzone();
    },

    resyncSteps() {
      var self = this;
      this.updateTutorialDraft()
      this.resyncing = true;
      this.syncing = true;
      this.current_step = 0;
      this.saveStepsForRevert()
      this.resetStepTimes();
      this.setUpSlider();
      var elem = $('.steps.collapsible')[0]
      var instance = M.Collapsible.getInstance(elem);
      instance.close(self.current_step)
      setTimeout(function () {
        self.scrollToStep(0);
        
      }, 300)

    },
    resyncModal() {
      let self = this;
      if (!self.resyncing){
        var options = {};
        var elem = document.querySelector("#resyncModal");
        var instance = M.Modal.init(elem, options);
        instance.open();        
      }else{
        return;
      }
    },

    cancelResync() {
      let self = this
      self.resyncing = false;
      self.syncing = false;
      self.current_step = 0;
      this.revertStepsOnCancel()
      var elem = $('.steps.collapsible')[0]
      var instance = M.Collapsible.getInstance(elem);
      instance.open(0)
      self.selectStep(0)
    },

    resyncNext() {
      let self = this;
      this.canResyncNext = false
      let valzer = self.slider.noUiSlider.get();
      let start_time = parseFloat(valzer[valzer.length - 2]);
      let end_time = parseFloat(valzer[valzer.length - 1]);
      self.steps[self.current_step].start_time = start_time
      self.steps[self.current_step].end_time = end_time
      self.setUpSlider();

      if (Math.floor(self.video_duration) == Math.floor(end_time) && self.current_step + 1 < self.steps.length) {
        setTimeout(function () {
          var elem = document.getElementById('outOfTimeModal');
          var instance = M.Modal.getInstance(elem);
          instance.open();
        }, 250)
        return
      }

      if (self.current_step + 1 == self.steps.length) {
        // done resyncing, let's check if there's other steps
        self.resyncing = false;
        self.syncing = false;
        self.current_step = 0;
        self.updateTutorialDraft()
        setTimeout(function(){
          self.setUpSlider()
        }, 50)

      } else {
        setTimeout(function () {
          self.selectStep(self.current_step + 1)
        }, 500)
      }
    },

    // Save/Revert Step methods
    saveStepsForRevert() {
      this.editStepRevert = this.steps.map(function (step) {
        return Object.assign({}, step)
      })
    },

    revertStepsOnCancel() {
      this.steps = this.editStepRevert.map(function (step) {
        return Object.assign({}, step)
      })

      this.setUpSlider()
    },

    // Editing step methods
    selectStep(index) {
      console.log("Hello from template select step")
      $('.medium-editor-element').remove()

      var self = this;
      this.editing = false;
      this.syncing = this.resyncing;
      this.current_step = index;
      let step = this.steps[index];

      if (this.slider) {
        var origins = this.slider.getElementsByClassName("noUi-origin");
        origins[0].setAttribute("disabled", true);
        origins[1].removeAttribute("disabled");

        self.setUpSliderColors()
      }
      try{
        if(this.video_url){
          jwplayer().seek(parseFloat(step.start_time));
          jwplayer().pause(true);
        }
      }catch(err){
        setTimeout(function () {
          self.selectStep(index);
        }, 3000)
      }

      setTimeout(function () {
        self.scrollToStep(index);
        self.resizeHandler();
      }, 100)
    },

    editStep(index) {
      let self = this

      setTimeout(function () {
        self.saveStepsForRevert()
        self.editing = true;
        self.current_step = index;
        setTimeout(function () {
          self.setUpEditor();
          self.scrollToStep(index);
          $("#stepFormTitle").trigger("focus");
        }, 10)
      }, EFFECT_DURATION)


    },

    scrollToStep(index) {
      let wrapPadding = 55 * (index + 1) + 58
      document.getElementById('scrollToContainer').style.paddingBottom = wrapPadding + 'px'
      setTimeout(function () {
        let scrollTo = $("#step_" + index)[0].offsetTop;

        $("#steps-gradient-scroller").animate(
          {
            scrollTop: scrollTo
          },
          300
        );
      }, 350)

    },

    syncVideo() {
      this.updateTutorialDraft()
      this.syncing = !this.syncing;
    },

    updateStep() {
      let self = this
      self.syncing = false
      setTimeout(function () {
        self.updatingStep = true
        self.updateTutorialDraft(function () {
          $('.medium-editor-element').remove()

          self.editing = false
          self.updatingStep = false
        })
      }, EFFECT_DURATION)
    },

    cancelEdit() {
      let self = this
      setTimeout(function () {
        $('.medium-editor-element').remove()
        self.editing = false
        self.syncing = false
        self.revertStepsOnCancel()
        self.updateTutorialDraft()
      }, EFFECT_DURATION)
    },

    deleteStep(i) {
      let self = this;
      let id = this.steps[i].id;
      
      setTimeout(function () {
        self.steps.splice(i, 1);
        if (self.video_url) {
          self.needsResync = true;
          self.updateTutorialDraft(function () {
            self.resyncSteps()
          })
        } else {
          self.updateTutorialDraft()
        }
      }, EFFECT_DURATION)

    },

    addAnother(cb) {
      let self = this;
      $('.medium-editor-element').remove()

      this.syncing = false;
      let start_time = this.steps[this.steps.length - 1].end_time;
      this.steps.push({
        title: "",
        new:true, 
        description: "",
        start_time: start_time,
        end_time: parseFloat(start_time) + 1,
        i: self.steps.length
      });

      self.current_step = self.steps.length - 1;
      self.setUpSlider();
      setTimeout(function () {
        self.editStep(self.steps.length - 1);
        self.updateTutorialDraft();
      }, 250);
    },

    // Save Tutorial Methods
    goToPreview() {
      let self = this;
      self.loadingPreview = true
      self.updateTutorialDraft(function () {
        window.location = "/tutorials/preview/" + self.tutorial.id
      })
    },

    updateTutorialDraft(cb) {
      let self = this
      let variables = this.originalTutorial
      if(updated_duration>0){
        this.video_duration=Math.floor(updated_duration);
      }
      this.steps.forEach(function (step) {
        if(step.new!=undefined){
          delete step.new
        }
      })
      let draft = {
        steps: this.steps,
        description: this.description,
        title: this.title,
        time_to_complete: this.time_to_complete,
        video_url: this.video_url,
        raw_url: this.raw_url,
        video_duration: this.video_duration
      }

      draftFields.forEach(function (field) {
        if (!draft[field]) {
          if (self[field]) {
            draft[field] = self[field]
          } else if (self.tutorial && self.tutorial[field]) {
            draft[field] = self.tutorial[field]
          }
        }
      })

      variables.draft = JSON.stringify(draft)
      GqlQuery.updateTutorial(variables, (err, result) => {
        if (err) {
          this.error = err;
          M.toast({
            html:
              "There was an error updating your tutorial, please try again or contact Fyiio support",
            inDuration: 3000
          });
        } else {
          self.lastUpdated = new Date();
          $('#lastUpdated').show()
          $('#lastUpdatedDate').html(new Date().toLocaleTimeString())
          if (cb && typeof cb == 'function') {
            cb()
          }
        }
      });
    },

  },
  components: {
    Sidebar,
    Steps,
    Stepper,
    EditorNav
  }
};


// WEBPACK FOOTER //
// ./src/containers/dashboard/template/template.js